module.exports = __webpack_public_path__ + "static/media/paw-alt.34b162cd.svg";